export const getStyle = (
  props: boolean | string | undefined,
  value1: string,
  value2?: string,
) => (props ? value1 : value2 || "")
